// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".photo-enter .photo-wrapper[data-v-65cf8d1b],.photo-leave-active .photo-wrapper[data-v-65cf8d1b]{opacity:0;transition:opacity .45s ease-in-out}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
